import DeckBuilder from '../assets/img/builder1.jpg';
import PokeFacts from '../assets/img/pokefacts.jpg';
import FaceborkHome from '../assets/img/faceborkhome.jpg';
import MTGHome from '../assets/img/deckbuilder-project/mtghome.jpg';
import VueTour from '../assets/img/deckbuilder-project/vue-tour.jpg';
import PokeHome from '../assets/img/pokefacts-project/poke-home.jpg';
import PokeSearch from '../assets/img/pokefacts-project/poke-search.jpg';
import PokeItems from '../assets/img/pokefacts-project/poke-items.jpg';
import DogRated from '../assets/img/facebork-project/dograted.jpg';
import DogError from '../assets/img/facebork-project/error.jpg';
import HooyosHome from '../assets/img/hooyos-project/Home-Desktop.jpg';
import HooyosAdminHome from '../assets/img/hooyos-project/admin-home.jpg';
import HooyosPhotoUploader from '../assets/img/hooyos-project/photouploader.jpg';
import HooyosEventsCrud from '../assets/img/hooyos-project/events-crud.jpg';
import IlluminateHome from '../assets/img/illuminate-project/illuminate-home.jpg';
import IlluminateForm from '../assets/img/illuminate-project/illuminate-form.jpg';

export const projects = [
    { 
      title: 'The Hooyo\'\s Network',
      image: HooyosHome,
      technology: 'ReactJS | React Router DOM | Redux | Material-UI',
      blurb: 'A marketing website and custom content management system for a 501(c)3 organization.',
      sourceCode: null,
      summary: 'The Hooyo’s Network website is both a responsive web presence for a new 501(c)3 organization and a custom content management system. As Team Lead and Principal Front End Developer, I was responsible for: serving as a point of contact for the client, gathering and analyzing user research, composing and maintaining the Trello board, overseeing scrum meetings, creating low-fidelity wireframes, collaborating with the design team, providing direction to backend developers, building all front end code, composing all written content, creating thorough user documentation, performing end-to-end testing, and deploying the application.',
      projectImages: 
        [
          {
            altText: 'home page of Hooyos Network website',
            url: HooyosHome,
            caption: 'The client wanted a simple, clean look for the responsive home page and a concise, clear explanation of the organization\'\s mission. I reviewed the basics of Material Design with the UX/UI team, gave them a brief overview of the Material-UI component library, and handed off my user research and wireframes.'
          },
          {
            altText: 'the admin home page',
            url: HooyosAdminHome,
            caption: 'In order to provide the client with a way to review and manage content without depending on developers, I built a custom content management system. The administrative panel allows the client to post new resources, keep track of event volunteers, create new events, and access or update volunteer contact information. The protected administrative routes are accessed via a secure login panel. I used React Redux for global state management to handle passing of data sets between components, global error handling, and user authentication.'
          },
          {
            altText: 'admin events table',
            url: HooyosEventsCrud,
            caption: 'The events management panel on the administrative side of the application enables the client to create, read, update, and delete events.'
          },
          {
            altText: 'photo uploader in add event form',
            url: HooyosPhotoUploader,
            caption: 'On the event creation form, I implemented a third party library for the client to properly crop and resize images to best fit the responsive layout. This feature simplifies the content creation process for non-technical users.'
          }
        ],
      video: 'https://www.youtube.com/embed/3kglO4-PxBc'
    },
    { 
      title: 'Illuminate, Inc.',
      image: IlluminateHome,
      technology: 'ReactJS | React Router DOM | Redux | Material-UI',
      blurb: 'Configurable landing pages and a complex form for a construction company.',
      sourceCode: null,
      summary: 'Illuminate, Inc. is a home construction company based in Austin, TX. My contributions to this project include a series of configurable, service-specific landing pages and a technician sign up form that creates a Square account and an Illuminate, Inc. profile upon submission.',
      projectImages: 
        [
          {
            altText: 'powerwashing landing page',
            url: IlluminateHome,
            caption: 'Illuminate offers twelve different types of services across a wide variety of industries, but why create twelve separate landing pages when one will suffice?  To save time, I built one responsive landing page and used a config file to store all the text and images that would be passed through depending on which route a user accesses.'
          },
          {
            altText: 'technician sign up form',
            url: IlluminateForm,
            caption: 'The client requested a method for technicians to sign up to contract under Illuminate, Inc. that simultaneously creates a company account and a Square account. Using Formik and Yup, I built this form according to specifications listed in the Square API.'
          }
        ],
      video: 'https://www.youtube.com/embed/wjtCsvNtIQo'
    },
    { 
      title: 'MTG Deck Builder',
      image: DeckBuilder,
      technology: 'VueJS | Vue Router | Vuex | Vuetify',
      blurb: 'An application for building, editing, and exporting card decks using the official Magic: The Gathering API.',
      sourceCode: 'https://github.com/kleinemmac/deck-picks',
      summary: 'MTG Deck Builder is a client-side, single-page, desktop web application by which a user can search for cards, build and edit a deck, and export it for later reference - all utilizing the MTG Card API. When I built this project, I did not have experience with backend development so I relied on IndexedDB to load and save state so that users could access their saved decks later.',
      projectImages: 
        [
          {
            altText: 'home page of Deck Builder desktop application',
            url: MTGHome,
            caption: 'The user begins with the option to edit an existing deck or create a new deck. Other options on existing decks include delete and export. The purple drawer to the right is a simple FAQ with guidelines and resources for building good Magic: The Gathering decks. The help icon at the top right triggers a vue-tour that explains the available options on the screen.'
          },
          {
            altText: 'create new deck option',
            url: DeckBuilder,
            caption: 'In this image, the user creates a new deck. Similar to the home page, the help icon at the top right triggers a vue-tour with specific guidelines for each available function. Filters at the top left allow the user to specify what legality, mana cost, color, and/or rarity they prefer. The user enters keywords into the search bar and an asynchronous search turns up sometimes thousands of results. These results are paginated so that they are easy to navigate. When a user selects one of the search results, it is displayed in the middle column with all of the vital information below it. The user can add the card using the purple + icon; they are able to delete a card from the deck by selecting the x icon next to it in the right column. Once the user exits this screen, their deck will be saved inside their browser unless they choose to delete all stored data.'
          },
          {
            altText: 'home page with vue-tour visible',
            url: VueTour,
            caption: 'I implemented a dark mode, minimalist design with a focus on functionality, simplicity, and clarity. I relied on intuitive icons, buttons, and controls to help the user navigate the application successfully. To cover any gaps in user experience and interaction, I provided thorough information via easily accessible and concise tours.'
          }
        ],
      video: 'https://www.youtube.com/embed/Z4W-YizJ0TU'
    },
    { 
      title: 'PokéFacts',
      image: PokeFacts,
      technology: 'VueJS | Vue Router | Vuex | Vuetify',
      blurb: 'A client-side web application for exploring parts of the PokéApi v2.',
      sourceCode: 'https://github.com/kleinemmac/pokefacts',
      summary: 'PokéFacts is a responsive, client-side, single-page web application for exploring parts of the PokéApi v2. To prepare for this project, I created hand-drawn, low fidelity wireframes and high fidelity prototypes for mobile, tablet, and desktop screen sizes using Adobe XD. PokéFacts relies on Vuex for global store/state management and error handling.',
      projectImages: 
        [
          {
            altText: 'home page of PokéFacts application',
            url: PokeHome,
            caption: 'In terms of design, I contrasted the whimsical Pokémon font styles with a minimalist and functional UX/UI approach. The clear and concise instructions, in combination with the global, collapsible navigation bar, enable the user to start searching for specific information quickly.'
          },
          {
            altText: 'search results from Pokémon Search displaying two Pokémon',
            url: PokeSearch,
            caption: 'The Pokémon search bar populates a list of results. When the user selects a Pokémon name, the appropriate sprite with a link to more comprehensive information appears.'
          },
          {
            altText: 'detailed results for a Pokémon item',
            url: PokeItems,
            caption: 'Each of the four main search options functions this way except each comprehensive information section is customized according to the data available from the API.'
          }
        ],
        video: 'https://www.youtube.com/embed/VIr0jz8cVtU'
    },
    { 
      title: 'Facebork',
      image: FaceborkHome,
      technology: 'VueJS | Vuetify | ML5/TensorFlow',
      blurb: 'A web application that relies on AI/ML to identify and rate an image of a dog uploaded by a user.',
      sourceCode: 'https://github.com/kleinemmac/facebork',
      summary: 'Facebork is a desktop web application that relies on AI/ML to provide a rating for an uploaded image with a satisfactory confidence score. Despite this being my first project, I wanted to start with something ambitious and different, so AI/ML seemed like a promising direction. The model I originally selected ended up not being a good fit due to it attempting to identify a large list of elements in a given image. Eventually, I found a good fit with a model that identifies dogs and their breeds.',
      projectImages: 
        [
          {
            altText: 'home page of FaceBork application with image uploader and animated dog',
            url: FaceborkHome,
            caption: 'The user is prompted to drag & drop an image or click to browse files in order to upload a picture of their dog to receive a rating. Walking Dog bounces with gleeful anticipation.'
          },
          {
            altText: 'error dialog that displays if confidence score is not satisfied',
            url: DogError,
            caption: 'File validation prevents the user from uploading a file that is too large and instructs them to try another file. If the image fails to meet the confidence threshold, it prompts the user to try uploading a picture that actually contains a dog. If the file passes size validation and satisfies the confidence score, Walking Dog is ready for action.'
          },
          {
            altText: 'rated dog image with option to rate another image',
            url: DogRated,
            caption: 'Upon acceptance of the image, Walking Dog trots across the screen, exits stage right, and re-enters, prepared for his next mission. The user receives a rating for their dog and is prompted to upload another picture. Walking Dog is a CSS animation by David Khourshid.'
          }
        ],
        video: 'https://www.youtube.com/embed/OVaFZEqU0bs'
    }
  ]